import HeroSection from '@/components/sections/HeroSection';
import ResidencyExperienceSection from '@/components/sections/ResidencyExperienceSection';
import HowItWorksSection from '@/components/sections/HowItWorksSection';
import AccommodationSection from '@/components/sections/AccommodationSection';
import StudioEquipmentSection from '@/components/sections/StudioEquipmentSection';
import TrustedArtistsSection from '@/components/sections/TrustedArtistsSection';
import SummerChanceSection from '@/components/sections/SummerChanceSection';
import TeamSection from '@/components/sections/TeamSection';
import PricingSection from '@/components/sections/PricingSection';
import LocationSection from '@/components/sections/LocationSection';
import FAQSection from '@/components/sections/FAQSection';

const HomePage = () => {
  return (
    <div>
      <HeroSection />
      <ResidencyExperienceSection />
      <HowItWorksSection />
      <AccommodationSection />
      <StudioEquipmentSection />
      <TrustedArtistsSection />
      <SummerChanceSection />
      <TeamSection />
      <PricingSection />
      <LocationSection />
      <FAQSection />
    </div>
  );
};

export default HomePage;
